import { PackageDTO } from '@luminovo/api-contracts';
import { isPresent } from '@luminovo/commons';

export function formatPackage(
    pack: (Pick<PackageDTO, 'name' | 'number_of_pins'> & { mounting?: string | null }) | null | undefined,
): string {
    if (!pack) {
        return '-';
    }
    return [pack.name, pack.mounting, pack.number_of_pins ? pack.number_of_pins + ' pins' : null]
        .filter(isPresent)
        .join(' ');
}
